import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { ApiLog } from '@/services/logsManagement/logsMangement.types';
import * as React from 'react';
import { ApiLogsForm } from '../../ApiLogsForm';
import { getColumns } from './Column';

export const ApiLogsTable = ({ data }: { data: ApiLog[] }) => {
  const { onOpen } = useDialogFormStore();

  const columns = React.useMemo(() => getColumns(), []);

  const onAddnew = () => {
    onOpen({
      modalTitle: 'pointManagement.page.form.manageSlabs.title',
      title: 'Manage Api Response Messages',
      okText: 'Confirm',
      size: 'lg',
      cancelText: 'No',
      component: <ApiLogsForm />,
    });
  };

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'sn', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: 'Api Logs',
      action: onAddnew,
    },
    getRowId: (originalRow) => String(originalRow.sn),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <div>
      <DataTable table={table} className="rounded-t-none rounded-b-xl">
        <DataTableToolbar />
      </DataTable>
    </div>
  );
};
